import { Capacitor } from '@capacitor/core';
export const isPrd = () => window.location.hostname === 'choirpal.com';

export const isStaging = () =>
  window.location.hostname === 'staging.choirpal.com';

export const isNative = () =>
  Boolean(window.cordova) ||
  Boolean(Capacitor && Capacitor.isNative && Capacitor.isNative());
